import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import Sidebar from "./layout/Sidebar";

export default function UserPanel() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [addform, setaddform] = useState(false);

  const handleDelete = (id) => {
    if(!confirm("Delete confirmation!")) {return;} 
    axios.delete(`${process.env.REACT_APP_BASE_URL}api/user/secured/deleteUser/`+id)
        .then(result=>{alert("Delete Successfully!");getData();})
        .catch(err=>console.log(err));
  };

  const columns = [
    { name: "ID", selector: row => row.id, sortable: true },
    { name: "FullName", selector: row => row.fullname || "N/A", sortable: true },
    { name: "email", selector: row => row.email || "N/A", sortable: true },
    { name: "Mobile", selector: row => row.mobile || "N/A", sortable: true },
    { name: "Role", selector: row => row.role || "N/A", sortable: true },
    { name: "Status",selector: row => row.status || "N/A",sortable: true, cell: row => (
      <span
        style={{
          color: row.status==="Active" ? "green" : "red",
          fontWeight: 600,
        }}>{row.status || "N/A"}</span>),},

    // ✅ Actions Column
    {
      name: "Actions",
      cell: row => (
        <div className="d-flex">
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  function getData(status){
      axios.get(`${process.env.REACT_APP_BASE_URL}api/user/secured/getUserByStatus/`+status)
      .then(result=>setData(result.data))
      .catch(err=>console.log(err))
      .finally(setLoading(false));    
  }
  useEffect(()=>getData("Active"),[]);

  const filteredData = filterText
    ? data.filter(item =>
        (item.fullname || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (item.email || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (item.mobile || "").toLowerCase().includes(filterText.toLowerCase()) 
      )
    : data;

    return (<>
      <div className="container-fluid">
          <div className="row">
             <div className="col-12 col-md-3 col-lg-2 sidebar-container">
                 <Sidebar></Sidebar>
             </div>
             <div className="col-12 col-md-9 col-lg-10 main-container">
                 <div className="container mt-4">
                  <h2 className="text-center mb-3">User List</h2>
                  <hr />
    
                  {/* Action Buttons + Search Bar */}
                  <div className="row d-flex justify-content-between align-items-center mb-0">
                    <div className="col-12 col-lg-2"></div>
                    <div className="col-12 col-lg-2">
                      <select className="form-select" name="status" onChange={(e)=>getData(e.target.value)}>
                        <option>Active</option>
                        <option>Inactive</option>
                      </select>
                    </div>
                    <div className="col-12 col-lg-3">
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "100%" }}
                        placeholder="Search"
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* Data Table */}
                  <div className="card shadow" style={{overflow:"auto"}}>
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={filteredData}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        striped
                      />
                    </div>
                  </div>
                </div>
             </div>
          </div>
      </div> 
    </>);
}